import type { IconData } from '@stacksjs/iconify-core'

export const videogame: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 360h480V120H16Zm32-208h416v176H48Z\"/><path fill=\"currentColor\" d=\"M152 184h-32v40H80v32h40v40h32v-40h40v-32h-40zm184 72h32v32h-32zm64-64h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default videogame
